import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CheckmarkStyled = styled.svg`
  position: absolute;
  top: -1px;
  right: -1px;
  width: 40px;
  height: 40px;
`;

export const Checkmark = ({ checked }) => (
  <div>
    <CheckmarkStyled
      id="select_svg"
      className={[
        'narvar-checkmark',
        'selectCheckmark-module_checkmark',
        checked && 'checkmark-selected',
      ]
        .filter(Boolean)
        .join(' ')}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      ariaLabel={checked ? 'selected' : 'unselected'}
      role="img"
    >
      <style>{'.st0{ fill:#ccc }.st1{ fill:none }'}</style>
      <path className="checkmark-fill st1" d="M39 37.6V1H2.4z" />
      <path
        className="checkmark checkmark-outline st0"
        d="M0 0l28 28 12 12V0H0zm39 37.6L2.4 1H39v36.6z"
      />
      <path
        className="checkmark checkmark-icon st0"
        d="M25.5 15.5L22 12l-1.2 1.2 4.7 4.6 10-10-1.2-1.1z"
      />
    </CheckmarkStyled>
  </div>
);

Checkmark.defaultProps = {
  checked: false,
};

Checkmark.propTypes = {
  checked: PropTypes.bool,
};
